import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import GolfIcon from './GolfIcon';

interface ProfileNavButtonsProps {
  userId: string;
}

export const ProfileNavButtons: React.FC<ProfileNavButtonsProps> = ({ userId }) => {
  const { t } = useTranslation('MGP');
  const history = useHistory();

  return (
    <div className="flex flex-col bg-card">
      <button
        className="flex items-center justify-between p-4 rounded-xl border"
        onClick={() => history.push(`/u/${userId}/game`)}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center">
            <GolfIcon name="cart" className="text-primary size-6" />
          </div>
          <span>{t('played_rounds', 'Games')}</span>
        </div>
        <GolfIcon name="chevron-right" className="text-muted-foreground" />
      </button>

      <button
        className="flex items-center justify-between p-4 rounded-xl border"
        onClick={() => { history.push(`/u/${userId}/stats`) }}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center">
            <GolfIcon name="analytics" className="text-primary size-6" />
          </div>
          <span>{t('insights')}</span>
        </div>
        <GolfIcon name="chevron-right" className="text-muted-foreground" />
      </button>

      <button
        className="flex items-center justify-between p-4 rounded-xl border"
        onClick={() => history.push(`/u/${userId}/bag`)}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center">
            <GolfIcon name="golf-bag-2" className="text-primary size-6" />
          </div>
          <span>{t('bag', 'Bag')}</span>
        </div>
        <GolfIcon name="chevron-right" className="text-muted-foreground" />
      </button>
    </div>
  );
};
